import type { Movie } from '../../types and data/types.js';
import { getGenreName } from '../../types and data/genres.js';
import { fetchMovieById } from '../api/moviesService.js';
import { getQueueList, getWatchedList } from './movieListService.js';
import { applyTranslations } from '../language.js';

export function renderMovies(movies: Movie[], language: 'en-US' | 'pl-PL'): string {
  // If no movies found / library empty
  const moviesAmount = movies.length;
  if (moviesAmount === 0) {
    setTimeout(() => {
      applyTranslations();
    }, 0);

    return `<li><p data-translate="emptyLibrary"></p></li>`;
  }

  return movies
    .map(movie => {
      const roundedVoteAverage = Math.round(movie.vote_average * 10) / 10;
      const genreNames = movie.genre_ids.map(genreId => getGenreName(genreId, language));
      const fallbackImage = new URL('../../images/no-video.webp', import.meta.url).toString();

      const imagePath = movie.backdrop_path
        ? // const imagePath = movie.poster_path
          `https://image.tmdb.org/t/p/w500${movie.backdrop_path}`
        : fallbackImage;

      return `<li class="films__list-item ${genreNames.slice(0, 2).join(' ')}" data-id="${movie.id}">
        <button type="button" class="films__list-item--button">
          <img src="${imagePath}" alt="${movie.title}" />
          <h2>${movie.title}</h2>
          <p>${genreNames.slice(0, 2).join(', ')} | <span>${movie.release_date.substring(0, 4)}</span>
          <span class="films__list-item--rating">${roundedVoteAverage}</span></p>
        </button>
      </li>`;
    })
    .join('');
}

export async function fetchQueuedMovies(language: string): Promise<Movie[]> {
  const ids = getQueueList();

  if (ids.length === 0) return [];

  const movies = await Promise.all(ids.map(id => fetchMovieById(id, language)));

  return movies.map(movie => ({
    id: movie.id,
    title: movie.title,
    backdrop_path: movie.backdrop_path,
    poster_path: movie.poster_path,
    release_date: movie.release_date,
    vote_average: movie.vote_average,
    genre_ids: movie.genres.map(g => g.id),
  }));
}

export async function fetchWatchedMovies(language: string): Promise<Movie[]> {
  const ids = getWatchedList();

  if (ids.length === 0) return [];

  const movies = await Promise.all(ids.map(id => fetchMovieById(id, language)));

  return movies.map(movie => ({
    id: movie.id,
    title: movie.title,
    backdrop_path: movie.backdrop_path,
    poster_path: movie.poster_path,
    release_date: movie.release_date,
    vote_average: movie.vote_average,
    genre_ids: movie.genres.map(g => g.id),
  }));
}
